import React, { useState,useEffect } from 'react'
import CommonSEOTitle from '../../../../helpers/CommonSEOTitle'
import AccountNavigation from '../Navigation/AccountNavigation'
import { Col, FormLabel, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useGetProfile } from '@hooks';
import { onDefaultError } from '../../../../helpers/commonHelpers'

const OtherPage = ({ t }) => {

    const navigate = useNavigate();
    const [data, setData] = useState({});

    const { refetch, isLoading } = useGetProfile(
        ({ data: profile }) => {
            if (profile) {
                setData(profile);
            }
        },
        (error) => {
            onDefaultError(error);
        }
    );

    useEffect(() => {
        if(data?.user_type && data?.user_type != 2){
            navigate(`/my-profile`);
        }
    },[data]);


    return (
        <>
            {data && Object.keys(data).length > 0 ? (

                <div>
                    <CommonSEOTitle title={t('page.my_profile_other')} />
                    {/* Navigation */}
                    <AccountNavigation t={t} formatted_joining_date={data?.formatted_joining_date} formatted_last_working_date={data?.formatted_last_working_date} data={data}/>

                    <Row className='px-4 mt-4'>
                        {/* Employee Code */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='control-label'>
                                {t('page.user_other_employee_code_label')}
                            </FormLabel>
                            <div className='user-info-value'>
                                {data?.employee_code}
                            </div>
                        </Col>

                        {/* Working Hours */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='control-label'>
                                {t('page.user_other_working_hours_label')}
                            </FormLabel>
                            <div className='user-info-value'>
                                {data?.working_hours}
                            </div>
                        </Col>

                        {/* Shift Start Time */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='control-label'>
                                {t('page.user_other_shift_start_time_label')}
                            </FormLabel>
                            <div className='user-info-value'>
                                {data?.shift_start_time}
                            </div>
                        </Col>

                        {/* Engagement Type */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='control-label'>
                                {t('page.user_engagement_type_label')}
                            </FormLabel>
                            <div className='user-info-value'>
                                {data?.engagement_type_text
                                    ? data?.engagement_type_text
                                    : data?.engagement_type == 1
                                        ? 'Full Time'
                                        : data?.engagement_type == 2
                                            ? 'External Vendor'
                                            : data?.engagement_type == 3
                                                ? 'Freelancer'
                                                : '-'}
                            </div>
                        </Col>

                        {/* Is Remote */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='control-label'>
                                {t('page.user_other_is_remote_label')}
                            </FormLabel>
                            <div className='user-info-value'>
                                {data?.is_remote == 1 ? 'Yes' : data?.is_remote == 2 ? 'No' : '-'}
                            </div>
                        </Col>

                        {/* Need to log hours based on task */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='control-label'>
                                {t('page.user_need_to_log_hours_label')}
                            </FormLabel>
                            <div className='user-info-value'>
                                {data?.need_to_log_hours == 1 ? 'Yes' : data?.need_to_log_hours == 2 ? 'No' : '-'}
                            </div>
                        </Col>
                    </Row>
                </div>) : null}
        </>
    );
}

export default OtherPage
